import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {icJWT_Account, IncidentRecord, IncidentSearchParams, LabInfo, ReportRecord} from "../../NIBINInterface";
import {AuthService} from "../../services/auth.service";
import {DropdownService} from "../../services/dropdown.service";
import {IncidentService} from "../../services/incident.service";
import {MatDialog} from "@angular/material/dialog";
import {animate, state, style, transition, trigger} from "@angular/animations";
import {ReportService} from "../../services/report.service";
import {MatTabChangeEvent, MatTabGroup} from "@angular/material/tabs";
import {ComposeEmailComponent} from "../email/compose-email/compose-email.component";
import {DownloadService} from "../../services/download.service";
import {GridComponent} from "@syncfusion/ej2-angular-grids";
import {Tab, TabComponent} from "@syncfusion/ej2-angular-navigations";
import Swal from "sweetalert2";
import {EmailLogsComponent} from "../email/email-logs/email-logs.component";

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
  providers: [DropdownService, IncidentService, ReportService, DownloadService]
})
export class ReportsComponent implements OnInit, AfterViewInit {

  user: icJWT_Account = <icJWT_Account>{};
  searchParams: IncidentSearchParams = <IncidentSearchParams>{};
  labs: LabInfo[] = [];
  dataSource2:ReportRecord[] = [];

  //for "new" report
  incidentsImport : IncidentRecord[] = [];
  //for "edit" report
  incidentsEdit : IncidentRecord[] = [];
  reportInfoEdit: ReportRecord = <ReportRecord>{}

  expandedElement: ReportRecord | null = null;
  @ViewChild("ListGrid") public ListGrid!: GridComponent;
  @ViewChild("TabGrid") public tabObj!: TabComponent;

  //@ViewChild('bodyTabs') bodyTabs!: MatTabGroup;

  constructor(private authService: AuthService,private downloadService: DownloadService,private dropdownService: DropdownService,private incidentService: IncidentService,private reportService: ReportService, public dialog: MatDialog) {
    this.user = this.authService.getUser()
    this.loadLabsList();
    this.loadDefaultReportData();

  }

  ngOnInit(): void {
  }
  ngAfterViewInit() {

  }

  async loadLabsList(): Promise<void>{
    this.labs = await this.dropdownService.getLabsList();
  }

  async loadDefaultReportData():Promise<void> {
    this.dataSource2 = await this.reportService.getLatestReport(this.user.CurrentDept)
  }

  async searchReports(params: IncidentSearchParams) : Promise<void> {
    this.dataSource2 =  await this.reportService.searchReports(params);
  }

  DownloadPDF(ReportID: string) {
    this.downloadService.DownloadNIBINReport(ReportID)
  }

  importToNewReport(report:ReportRecord) {
    if(report.Incidents){
      this.incidentsImport = [...report.Incidents]
      this.tabObj.selectedItem=1;
    }
  }

  editReport(report:ReportRecord) {
    this.reportInfoEdit = report

    if(report.Incidents){
      this.incidentsEdit = [...report.Incidents]

    }
    this.tabObj.selectedItem=2;
  }

  modifyFormIsComplete(data: {ReportInfo:ReportRecord, Incidents:IncidentRecord[]}) {
    this.tabObj.selectedItem=0;
    this.loadDefaultReportData()
  }

  EmailReport(report: ReportRecord) {
    let ref = this.dialog.open(ComposeEmailComponent, {
      width: '60%',
      height: '80%'
    })
    ref.componentInstance.ReportInfo = report;

    ref.componentInstance.SentEvent.subscribe((val)=>{
        report.ReportStatus='COMPLETE'

        if(this.dataSource2){
          let temp = JSON.parse(JSON.stringify(this.dataSource2));
          this.dataSource2=[];
          this.dataSource2=temp;
        }

        this.loadDefaultReportData(); //Force Reloaded the Latest 25
        ref.close();
    })
  }

  EmailLogs(report: ReportRecord){
    let ref = this.dialog.open(EmailLogsComponent, {
      width: '60%',
      height: '80%'
    })
    ref.componentInstance.ReportInfo = report;
  }

  reload(event: boolean) {
    if(event)
      this.loadDefaultReportData()
  }

  async tabChanged($event: MatTabChangeEvent) {
    //await this.loadDefaultReportData()
    if(this.ListGrid){
      this.ListGrid.refresh()
    }
      //this.ListGrid.detailRowModule.collapseAll();

  }

  async DeletePendingReport(report: ReportRecord) {
    Swal.fire({
      title: "Are you sure you want to Delete this Report?",
      showDenyButton: true,
      confirmButtonText: 'Yes',
      confirmButtonColor:'darkblue',
      denyButtonText: `No`,
      denyButtonColor:'darkblue',
      timer: 10000,
      timerProgressBar: true,
      reverseButtons: true,
    }).then(async (result) => {

      if (result.isConfirmed) {
        if(report.ReportID){
          let r = await this.reportService.DeleteReport(report.ReportID)

        }
        this.loadDefaultReportData()
      }
    })

  }


  async RescindReport(report: ReportRecord) {
    Swal.fire({
      title: "Are you sure you want to Rescind this Report? (An Email will be Sent to Everyone who as received this Report)",
      showDenyButton: true,
      confirmButtonText: 'Yes',
      confirmButtonColor:'darkblue',
      denyButtonText: `No`,
      denyButtonColor:'darkblue',
      timer: 10000,
      timerProgressBar: true,
      reverseButtons: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        if(report.ReportID){
          let r = await this.reportService.RescindReport(report.ReportID)

        }
        this.loadDefaultReportData()
      }
    })
  }

  ViewLinkAnalysisReport(report: any) {
    let url = this.reportService.GetLinkAnalysisReportURL(report.ReportID).then(r=>{
      if(r){
        window.open(r, "_blank")
      }
    })
  }

  ViewTimeLineReport(report: any) {
    let url = this.reportService.GetTimeLineReportURL(report.ReportID).then(r=>{
      if(r){
        window.open(r, "_blank")
      }
    })
  }

  isReportAssociationsCompleted(report: ReportRecord) : boolean {
    let complete =  true

    if(report?.Incidents){
      for(let inc of report?.Incidents){
        let wArray = inc?.Weapon?.find(w=> !!w.SelectedForAssoc)?.SelectedForAssoc ?? false
        let bArray = inc?.Ballistics?.find(b=> !!b.SelectedForAssoc)?.SelectedForAssoc ?? false
         if(!wArray && !bArray)
            complete = false
      }
    }
    return complete;
  }
}
